import { ConnectorPosition } from '../../BrazilMiniMap'

type State = {
  regionHoverPosition: {
    x: string
    y: string
    placement: ConnectorPosition
  } | null
  regionKey: string | null
}

export enum ActionType {
  SET_REGION_HOVER_POSITION = 'SET_REGION_HOVER_POSITION',
  SET_REGION_KEY = 'SET_REGION_KEY'
}

export const initialState: State = {
  regionHoverPosition: null,
  regionKey: null
}

export type RegionHoverPosition = {
  x: string
  y: string
  placement: ConnectorPosition
} | null

type Action =
  | {
      type: ActionType.SET_REGION_HOVER_POSITION
      payload: RegionHoverPosition
    }
  | { type: ActionType.SET_REGION_KEY; payload: string | null }

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.SET_REGION_HOVER_POSITION:
      return { ...state, regionHoverPosition: action.payload }
    case ActionType.SET_REGION_KEY:
      return { ...state, regionKey: action.payload }
    default:
      return state
  }
}
